import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import DashboardLayout from '../../components/layouts/dashboard'
import UnauthorizedPage from '../errors/unauthorized'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import EmployeeManagement from './employee-management'
import SalaryManagement from './salary-management'

const AdminManagement = () => {
  const { user } = useSelector((state) => state.userSlice)
  const [unauthorized, setUnauthorized] = useState(false)
  const [currentLocation, setCurrentLocation] = useState('employees')

  const location = useLocation()
  let isAdmin =
    user?.company?.employee?.permission_employee_read === 1 ||
    user?.company?.employee?.permission_employee_write === 1 ||
    user?.company?.employee?.permission_salary_read === 1 ||
    user?.company?.employee?.permission_salary_write === 1

  useEffect(() => {
    if (location) {
      setCurrentLocation(location.pathname.split('/')[1])
    }
  }, [location])
  useEffect(() => {
    if (user) {
      if (user?.company?.hr_subscription !== 1 && !isAdmin) {
        setUnauthorized(true)
      }
    }
  }, [user])

  return (
    <DashboardLayout title='Admin Management'>
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <main className='flex flex-col gap-2.5'>
          {currentLocation === 'employees' ? (
            <>
              {user?.company?.hr_subscription === 1 && isAdmin ? (
                <EmployeeManagement />
              ) : (
                <UnauthorizedPage />
              )}
            </>
          ) : currentLocation === 'salaries' ? (
            <>
              {user?.company?.hr_subscription === 1 && isAdmin ? (
                <SalaryManagement />
              ) : (
                <UnauthorizedPage />
              )}
            </>
          ) : null}
        </main>
      )}
    </DashboardLayout>
  )
}

export default AdminManagement
